"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useImmediateEffect;

var _react = require("react");

function useImmediateEffect(fn, deps) {
  var unsubscribeRef = (0, _react.useRef)({
    first: true,
    id: Math.random().toString(36).substr(2, 5),
    unsubscribe: fn()
  });
  (0, _react.useEffect)(function () {
    var current = unsubscribeRef.current;

    if (!current.first) {
      current.unsubscribe = fn();
    } else {
      current.first = false;
    }

    return function () {
      current.unsubscribe && current.unsubscribe();
      current.unsubscribe = null;
    };
  }, deps);
}